import { Component, input, OnInit, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { MediaService } from '@app/services/media.service';

@Component({
    selector: 'clever-bosysimagelist',
    imports: [],
    templateUrl: './bosysimagelist.html',
    styleUrl: './bosysimagelist.scss'
})
export class Bosysimagelist implements OnInit {

    objlist = input<any[]>([]);
    name = input<any>(null);

    images = signal<string[]>([]);

    constructor(
        protected mediaService: MediaService,
        protected dialog: MatDialog
    ) { }

    ngOnInit(): void {
        // console.log(this.objlist());
        for (let i = 0; i < this.objlist().length; i++) {
            this.images().push(this.objlist()[i].content);

        }
    }

    async openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: { name: this.name() },
                images: this.images(),
                videos: [],
                current: ev,
                to800: true,
                nocache: true,
                desktopTemplate: this.mediaService.media()
            }
        }
        this.dialog.open(TvangebotimagevideoComponent, target);
    }

}
